import Template, { TemplateProps } from '@/components/Template';
import { usePageTitle } from 'lib/usePageTitle';

/**
 * Wrapper template for Settings page that sets the title
 */
export const SettingsTemplate = (props: TemplateProps) => {
    usePageTitle(`${props.title} | Settings`);
    return <Template {...props} />;
};